<template>
  <div
    class="modal fade"
    id="cancelSubscription"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelTitleId"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content modal-subscription">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div
                class="d-flex justify-content-center align-items-center flex-column"
              >
                <img src="@/assets/icons/sad_smile.svg" height="90px" alt="" />
                <span class="plan-header mt-2">Lamentamos verte ir</span>
                <h3 class="mb-3 view-title">Aviso importante</h3>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-10 offset-1">
              <p class="plan-description text-center">
                Cancelar tu plan eliminará tu suscripción (anual o mensual), lo
                que significa que no se te cobrará en el siguiente periodo. Sin
                embargo, podrás utilizar Cotizarlo el tiempo que reste de tu
                periodo en curso.
                <br />
                <br />
                Al cancelar, a partir de tu fecha de corte, tu cuenta
                automáticamente será transformada a una cuenta gratuita. De esta
                forma, si te arrepientes y regresas a la plataforma, todas tus
                cotizaciones estarán disponible. Es importante notar que
                <strong
                  >se perderá cualquier configuración o personalización que
                  hayas realizado en tu cuenta</strong
                >, ya que esta se regresará al estado default de la app.
                <br />
                <br />
                Para el plan de Equipo, todas las cotizaciones creadas se
                asignarán al administrador de la cuenta, por lo que no podrás
                distinguir qué vendedor envió qué cotización, aún y volviendo a
                contratar el plan.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <button class="btn btn-warning" @click="cancelSuscription()">Entendido, quiero cancelar mi plan</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import plansService from "@/api/plans";
export default {
  beforeDestroy() {
    $(".modal-backdrop").remove();
  },
  methods:{
    cancelSuscription(){
      this.$store.dispatch("showLoader", { show: true });
      plansService.cancelSubscription().then(
        ()=>{
          this.$store.dispatch('client/setData').then(
            () => {
              $(".modal-backdrop").remove();
              $("#cancelSubscription").modal("hide");  
              this.$store.dispatch("showLoader", { show: false });
            }
          )
        }
      );
    }
  }
};
</script>